/**
 * Appliance pricing bands for use in the appliance details form.
 * These are used to determine which pricing band an appliance falls into based on its price.
 */
export const pricingBands = [
  { name: '0 - 99.99', min: 0, max: 99.99 },
  { name: '100 - 249.99', min: 100, max: 249.99 },
  { name: '250 - 499.99', min: 250, max: 499.99 },
  { name: '500 - 749.99', min: 500, max: 749.99 },
  { name: '750 - 999.99', min: 750, max: 999.99 },
  { name: '1,000 - 1,999.99', min: 1000, max: 1999.99 },
  { name: '2,000 - 4,999.99', min: 2000, max: 4999.99 },
  { name: '5,000 - 9,999.99', min: 5000, max: 9999.99 },
  { name: '10,000+', min: 10000, max: Infinity },
] as const;
